/* ==========================================================================
   treasure_castle_infinite_stream.js
   Infinite Product Stream — 商品コンベア（比較試作専用の追加スクリプト）

   ★ 既存の treasure_castle_home_motion.js は一切変更・参照しない。
     ブランドカルーセル（[data-carousel]）／ヒーロー切替のロジックには触れない。
   ★ 外部ライブラリを使用しない。fetch は同一オリジンの product_stream_data.json
     だけを読む（Shopify Admin・API・外部送信は行わない）。
   ★ 商品画像は Shopify の公開 CDN URL を <img> でそのまま参照する
     （事前の一括ダウンロードはしない。ブラウザが必要な分だけ都度取得する）。
   ★ DOM ノードは常に一定範囲だけを保持する仮想化ストリーム（全952件を
     一度に描画しない）。
   ========================================================================== */
(function () {
  "use strict";

  var SPEED_PRESETS = {
    fast:    70,    // px / 秒
    faster:  130,   // px / 秒（既定）
    extreme: 260    // px / 秒
  };
  var DEFAULT_SPEED = "faster";

  var BUFFER_AHEAD_PX = 420;   // 右端より先に確保しておく描画範囲（十数〜数十件分）
  var REMOVE_MARGIN_PX = 40;   // 左端をこの分だけ余分に過ぎたら破棄する

  function getSpeedKey() {
    try {
      var v = new URLSearchParams(window.location.search).get("speed");
      if (v && SPEED_PRESETS.hasOwnProperty(v)) return v;
    } catch (e) { /* URLSearchParams 非対応環境は既定値 */ }
    return DEFAULT_SPEED;
  }

  function fetchData(url) {
    return fetch(url, { cache: "no-store" }).then(function (r) {
      if (!r.ok) throw new Error("product_stream_data.json load failed: " + r.status);
      return r.json();
    });
  }

  function buildItemEl(doc, product) {
    var el;
    if (product.product_url) {
      el = doc.createElement("a");
      el.href = product.product_url;
      el.target = "_blank";
      el.rel = "noopener noreferrer";
    } else {
      el = doc.createElement("div");
    }
    el.className = "tc-stream__item";

    var img = doc.createElement("img");
    img.src = product.image_url;
    img.alt = product.alt_text || product.title || "";
    img.loading = "lazy";
    img.decoding = "async";
    el.appendChild(img);

    // ★ユーザー確認結果（案A採用・SOLD OUTバッジ非表示）を反映。
    //   product.available の値自体は変更・参照先も変えていない（在庫データは不変）。
    //   ストリーム上に「SOLD OUT」の可視文字を出力しないだけで、在庫切れ商品の
    //   画像・リンク・並び順は他の商品と同じ扱いのまま維持している。

    if (product.title) {
      var cap = doc.createElement("span");
      cap.className = "tc-stream__cap";
      cap.textContent = product.title;
      el.appendChild(cap);
    }
    return el;
  }

  function initStream(root, allProducts) {
    var track = root.querySelector(".tc-stream__track");
    if (!track || !allProducts.length) return;

    var reduceMQ = window.matchMedia("(prefers-reduced-motion: reduce)");
    var hoverMQ = window.matchMedia("(hover: hover)");

    // ---- 訪問ごとの開始位置（リロードのたびに変わる。データ自体は変更しない） ----
    var nextIndex = Math.floor(Math.random() * allProducts.length);
    function takeNext() {
      var p = allProducts[nextIndex];
      nextIndex = (nextIndex + 1) % allProducts.length;
      return p;
    }

    // ------------------------------------------------------------------
    // reduced-motion: 静止・手動スクロール表示（自動アニメーションはしない）
    // ------------------------------------------------------------------
    if (reduceMQ.matches) {
      root.setAttribute("data-mode", "scroll");
      var frag = document.createDocumentFragment();
      var STATIC_COUNT = Math.min(80, allProducts.length);
      for (var i = 0; i < STATIC_COUNT; i++) {
        frag.appendChild(buildItemEl(document, takeNext()));
      }
      track.appendChild(frag);
      return; // rAFループを開始しない
    }

    root.setAttribute("data-mode", "stream");

    var pos = 0;                 // track の translateX（0 以下へ減少し続ける）
    var items = [];              // { el, width } の配列（左→右の順）
    var running = true;          // Pause/Resume ボタンの状態
    var hoverPaused = false;     // PC のホバー中一時停止
    var lastTs = null;
    var speedPxPerSec = SPEED_PRESETS[getSpeedKey()] || SPEED_PRESETS[DEFAULT_SPEED];
    // ★検証用の読み取り専用メタ情報。公開UIではない（見た目には出ない属性値）。
    //   位置(transform)はカードのリサイクルのたびに巻き戻るため、速度比較の
    //   実測には生のtransform差分ではなく、この確定済み定数を使う。
    root.setAttribute("data-stream-speed-px-s", String(speedPxPerSec));
    root.setAttribute("data-stream-speed-key", getSpeedKey());

    function itemFullWidth(el) {
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      return el.getBoundingClientRect().width + gap;
    }

    function appendOne() {
      var el = buildItemEl(document, takeNext());
      track.appendChild(el);
      var w = itemFullWidth(el);
      items.push({ el: el, width: w });
      return w;
    }

    function totalTrackWidth() {
      var w = 0;
      for (var i = 0; i < items.length; i++) w += items[i].width;
      return w;
    }

    function fillAhead() {
      var viewportW = root.clientWidth;
      // pos は負値。トラック右端の画面上位置 = pos + totalTrackWidth()
      while (pos + totalTrackWidth() < viewportW + BUFFER_AHEAD_PX) {
        appendOne();
      }
    }

    function recycleBehind() {
      while (items.length > 1 && pos <= -(items[0].width + REMOVE_MARGIN_PX)) {
        var first = items.shift();
        pos += first.width;
        if (first.el.parentNode === track) track.removeChild(first.el);
      }
    }

    // 初期充填
    fillAhead();

    function step(ts) {
      if (lastTs === null) lastTs = ts;
      var dt = (ts - lastTs) / 1000;
      lastTs = ts;
      if (dt > 0.25) dt = 0.25;  // タブ非アクティブ復帰時の大ジャンプ防止

      var animate = running && !hoverPaused;
      if (animate) {
        pos -= speedPxPerSec * dt;
        track.style.transform = "translate3d(" + pos.toFixed(2) + "px,0,0)";
        recycleBehind();
        fillAhead();
      }
      root.__tcRaf = window.requestAnimationFrame(step);
    }
    root.__tcRaf = window.requestAnimationFrame(step);

    // ---- ホバーで一時停止（PCのみ。操作性は妨げない） ----
    if (hoverMQ.matches) {
      root.addEventListener("mouseenter", function () { hoverPaused = true; });
      root.addEventListener("mouseleave", function () { hoverPaused = false; });
    }

    // ---- Pause / Resume ボタン（英語のみ。常時表示の開発用UIではない） ----
    var ctrl = root.querySelector("[data-stream-ctrl]");
    if (ctrl) {
      ctrl.setAttribute("aria-pressed", "false");
      ctrl.setAttribute("aria-label", "Pause stream");
      ctrl.textContent = "❚❚"; // ❚❚
      ctrl.addEventListener("click", function () {
        running = !running;
        ctrl.setAttribute("aria-pressed", String(!running));
        ctrl.setAttribute("aria-label", running ? "Pause stream" : "Resume stream");
        ctrl.textContent = running ? "❚❚" : "▶";
      });
    }

    // 画面幅変更時に測り直す（items配列の width をキャッシュしているため再測定）
    var resizeTimer = null;
    window.addEventListener("resize", function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        for (var i = 0; i < items.length; i++) {
          items[i].width = itemFullWidth(items[i].el);
        }
        fillAhead();
      }, 150);
    });
  }

  function boot() {
    var roots = document.querySelectorAll("[data-stream-init]");
    if (!roots.length) return;
    var dataUrl = roots[0].getAttribute("data-stream-init") || "product_stream_data.json";
    fetchData(dataUrl).then(function (payload) {
      var products = (payload && payload.products) || [];
      for (var i = 0; i < roots.length; i++) initStream(roots[i], products);
    }).catch(function (err) {
      // データ取得に失敗した場合は、何も描画しない（壊れた見た目を出さない）
      for (var i = 0; i < roots.length; i++) roots[i].setAttribute("data-mode", "error");
      if (window.console) console.error("[tc-stream]", err);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
